import { render, staticRenderFns } from "./AcessarAtaItensBtnAcoes.vue?vue&type=template&id=7c1ce90a&scoped=true"
import script from "./AcessarAtaItensBtnAcoes.vue?vue&type=script&lang=js"
export * from "./AcessarAtaItensBtnAcoes.vue?vue&type=script&lang=js"
import style0 from "./AcessarAtaItensBtnAcoes.vue?vue&type=style&index=0&id=7c1ce90a&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1ce90a",
  null
  
)

export default component.exports